export const getOrderedCategories = (categories, order) => {
  if (!order || !categories) return [];

  return order
    .map((categoryId) =>
      categories.find((category) => category.id === categoryId)
    )
    .filter(Boolean);
};

export const getUnfoundCategories = (categories, order) => {
  if (!categories) return [];

  return categories
    .filter(({ id }) => !order?.includes(id))
    .sort((a, b) => a.title?.localeCompare(b.title));
};

export const getSortedCategories = (categories, order) => {
  const orderedCategories = getOrderedCategories(categories, order);
  const unfoundCategories = getUnfoundCategories(categories, order);

  return [...orderedCategories, ...unfoundCategories];
};
